<template>
  <div class="search">
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft">
      <template #title>
        <div class="search-cont">
          <form action="/">
            <van-search
              show-action
              placeholder="搜索艺术家，机构，作品，风格等"
              @search="onSearch"
              @cancel="onCancel">
              <template #action>
                <div @click="onSearch">搜索</div>
              </template>
            </van-search>
          </form>
        </div>
      </template>
    </van-nav-bar>
    <div class="history">
      <div class="h-header">
        <h3>历史记录</h3>
        <van-icon name="shanchu">清空</van-icon>
      </div>
      <ul class="records">
        <li v-for="item in records" :key="item.index">
          <div class="left">
            <van-icon name="shijian"></van-icon>
            <span>{{item.record}}</span>
          </div>
          <van-icon name="closed"></van-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data() {
    return {
      records: [
        {
          record: '收银员'
        },
        {
          record: '服务员'
        },
        {
          record: '电子测算师'
        }
      ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onSearch() {
      this.$router.push({ path: '/result' })
    },
    onCancel(){

    }
  }
}
</script>

<style lang="less" scoped>
  /deep/.van-nav-bar{
    background:url("../../../assets/img/searchbg.png") no-repeat center center;
    background-size: 100% auto;
    height: 52px;
    .van-icon{
      color: #fff;
    }
  }
  /deep/.search-cont{
    position: absolute;
    left:40px;
    top:0;
    right:16px;
    .van-search{
      background: none;
      border:0;
      .van-search__content{
        background: rgba(255,255,255,.3);
        border-radius: 50px;
        height: 35px;
      }
    }
    .van-cell{
      display: flex;
      align-items: center;
    }
    .van-search__action{
      color:#fff;
      font-weight: normal;
      font-size: 16px;
      margin-left: 10px;
    }
    i{
      color:#9FA6AF;
      font-size: 16px;
      margin-right: 4px;
    }
    input{
      color:#fff;
      font-size: 12px;
      &::placeholder{
        color:#fff
      }
    }
  }
  /deep/.van-field__control{
    font-weight: normal;
  }
  /deep/.van-hairline--bottom::after{
    display: none;
  }
  .history{
    margin:20px 16px;
    .h-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      h3{
        font-size: 14px;
        color:#25272B;
      }
      i.van-icon{
        font-size: 12px;
        color:#7D7D7D;
      }
    }
    .records{
      li{
        display: flex;
        justify-content: space-between;
        padding:16px 0;
        align-items: center;
        font-size: 14px;
        color:#515255;
        border-bottom: 1px solid #eee;
        &:last-child{
          border-bottom: 0;
        }
        .left{
          i{
            margin-right: 10px;
          }
        }

      }
    }
  }
</style>
